import { constants } from "../attributes/EquipmentCalculatedAlerts.js";
import FilterTranslatorConverter from "../../../attributes/filters/FilterTranslatorConverter.js";
import Util from "../../../locatorAlerts/Util.js"; // creates an object that lists out the filters from the constants object where the key is the constant value and the value is the filter object function
/**
 * Ex.
 * const filterTranslator = {
 *  [constants.THEFT_RECOVERY_ACTIVATED] : () => {
      return {
        type : 'equals',
        field : `data/locatorAlerts@/[constants.THEFT_RECOVERY_ACTIVATED]`,
        value : true
      },
    }, ...etc
 */
const createFilter = constant => () => {
  return {
    type: 'equals',
    field: `data/locator/data/locatorAlerts@/[${constant}]`,
    value: true
  };
};
let filterTranslator = Object.values(constants).reduce((acc, constant) => {
  acc[constant] = createFilter(constant);
  return acc;
}, {});

// add the filters that are not in the locatorAlerts list and are on the vehicle object instead
const specialFilters = {
  [constants.NOT_REPORTING]: () => {
    return Util.notReportingVehicleLocatorsFilter();
  },
  [constants.NOT_ACTIVATED]: () => {
    return {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'exists',
        field: 'data/locator/id'
      }, {
        type: 'exists',
        field: 'data/locator/data/lastHeartbeat',
        not: true
      }]
    };
  },
  [constants.NON_OPERATIONAL]: () => {
    return Util.notOperationalVehicleLocatorsFilter();
  }
};

// merge special cases into filterTranslator
filterTranslator = {
  ...filterTranslator,
  ...specialFilters
};
export default FilterTranslatorConverter.create('assetLocators.calculatedAlerts', filterTranslator);